import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseKontaktySearch } from '@/modules/kontakty/filters';

const KontaktDetail = lazy(() =>
  import('@/modules/kontakty/KontaktDetail').then((m) => ({ default: m.KontaktDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/kontakty/$id',
  component: () => (
    <Suspense fallback={null}>
      <KontaktDetail />
    </Suspense>
  ),
  // Same shape as the list route so the detail's master rail shows the same
  // cohort (tab + name search) the user was browsing.
  validateSearch: parseKontaktySearch,
});
